import { render, staticRenderFns } from "./AIStrategy.vue?vue&type=template&id=527f4403&scoped=true"
import script from "./AIStrategy.vue?vue&type=script&lang=js"
export * from "./AIStrategy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527f4403",
  null
  
)

export default component.exports